import Controller from 'lib/controller'
import Collapsible from 'view/collapsible'

const PrivacyPolicy = Controller.extend({
    initialize() {
        this.initSubview(Collapsible, {
            el: this.$('.js-collapsible'),
        }).render()
    },
})

export default new PrivacyPolicy()
